import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) { navigate("/"); }
    else toast.error(r.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:block relative">
        <img
          src="https://images.unsplash.com/photo-1606857521015-7f9fcf423740?crop=entropy&cs=srgb&fm=jpg&w=1600&q=80"
          alt="Tim"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-forest/60" />
        <div className="relative z-10 p-12 flex flex-col justify-between h-full text-white">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-white/15 backdrop-blur grid place-items-center font-heading font-bold">V</div>
            <div className="font-heading text-xl font-semibold">Voden</div>
          </div>
          <div className="max-w-md">
            <h1 className="text-4xl font-heading font-semibold tracking-tight leading-tight">
              Jutro. Kafa. Šta danas dugujem — i šta duguju meni.
            </h1>
            <p className="mt-4 text-white/80">
              Organizuj timove po regionima, uparuj taskove sa saradnicima i pusti da ti jutro počne pregledno.
            </p>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="overline mb-2">Prijava</div>
          <h2 className="text-3xl font-heading font-semibold tracking-tight">Dobrodošli nazad</h2>
          <p className="text-sm text-ink-muted mt-2">Unesite email i lozinku da nastavite.</p>

          <div className="mt-8 space-y-4">
            <div>
              <label className="text-sm font-medium">Email</label>
              <input
                data-testid="login-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
                required
              />
            </div>
            <div>
              <label className="text-sm font-medium">Lozinka</label>
              <input
                data-testid="login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full mt-1 px-3 py-2.5 bg-white border border-line rounded-md focus:outline-none focus:ring-2 focus:ring-forest"
                required
              />
            </div>
            <button data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center">
              {loading ? "Prijavljivanje..." : "Prijavi se"}
            </button>
          </div>

          <div className="text-sm text-ink-muted mt-6 flex justify-between items-center">
            <Link to="/register" data-testid="link-register" className="text-forest font-medium hover:underline">Pošaljite zahtev</Link>
            <Link to="/forgot-password" data-testid="link-forgot" className="text-ink-muted hover:text-forest">Zaboravili ste lozinku?</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
